import { Component, OnInit, AfterViewInit, OnDestroy, Output, EventEmitter, Input, ElementRef, ViewChild, NgZone, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { Router } from '@angular/router';
import * as firebase from 'firebase';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { AuthenticateserviceService } from 'src/app/_service/authenticateservice.service';
import { countryPhoneCodes } from 'src/app/constants/phoneInternalization';
import { encrypt } from 'src/app/utils/encryptHelper';
import { CategoryService } from 'src/app/_service/category.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { RegistrationComponent } from '../../registration/registration.component';
import { TermsAndConditionsComponent } from '../../sharedComponents/terms-and-conditions/terms-and-conditions.component';
import { CustomControlsService } from 'src/app/_service/custom-controls.service';
import { TVNavigationService } from 'src/app/_service/tv-navigation.service';
import { TvKeyboardService } from 'src/app/_service/tv-keyboard.service';
import { DeviceService } from 'src/app/_service/tv-detect.service';
import { GuestTokenService } from 'src/app/_service/guest-token.service';

@Component({
  selector: 'app-email-auth',
  templateUrl: './email-auth.component.html',
  styleUrls: ['./email-auth.component.css']
})
export class EmailAuthComponent implements OnInit, AfterViewInit, OnDestroy {
  @Output() stepChange = new EventEmitter<number>();
  @Output() authTypeChange = new EventEmitter<string>();
  busy = false;
  public recaptchaVerifier: firebase.auth.RecaptchaVerifier;
  public sent: boolean;
  steps = 1;
  confirmationResult;
  formGroup: FormGroup;
  windowRef: any;
  invalidOtpError: string = 'auth/invalid-verification-code';
  invalidOtp: boolean = false;
  appComponent: any;
  remainingTime: number = 60;
  isResendDisabled: boolean = false;
  loading:boolean = false;
  verificationId:string = '';
  @Input() deviceId:string;
  @Input() selectedCountry:string;
  @Input() authMethods: any[] = [];
  separateDialCode = false;
  otpValue: string = '';
  showOtp: boolean = false;
  otpInputKey: string = 'initial';
  @ViewChild('otpContainer', { static: false }) otpContainer: ElementRef;
  @ViewChild('ngOtpInput', { static: false }) ngOtpInput: any;
  otpConfig = {
    length: 6,
    inputClass: 'custom-otp-input',
    allowNumbersOnly: true,
    isPasswordInput: false,
    autofocus: true,
    inputType: 'tel',
  };

  // TV Navigation properties (step 1)
  @ViewChild('emailInput', { static: false }) emailInput: ElementRef;
  @ViewChild('tcCheckbox', { static: false }) tcCheckbox: ElementRef;

  // Shared between steps (both have submit button)
  @ViewChild('submitBtn', { static: false }) submitBtn: ElementRef;

  // TV Navigation properties (step 2)
  // Wrong number button uses a setter because the step-2 *ngIf race causes
  // the ViewChild to populate AFTER our 100ms/600ms re-register catch-ups
  // run. The setter fires the moment Angular binds the ref, so we re-register
  // synchronously on bind — guaranteeing Wrong enters the focus list.
  private _wrongNumberBtn: ElementRef;
  @ViewChild('wrongNumberBtn', { static: false })
  set wrongNumberBtnRef(el: ElementRef) {
    this._wrongNumberBtn = el;
    if (el && this.isTV && this.steps === 2) {
      setTimeout(() => this.registerFormNavigation(), 0);
    }
  }
  get wrongNumberBtn(): ElementRef { return this._wrongNumberBtn; }

  @ViewChild('resendBtn', { static: false }) resendBtn: ElementRef;

  // Fallback link uses a setter for the same reason as wrongNumberBtn above:
  // it's gated by *ngIf="backupAuthMethod" which becomes truthy only after
  // the async authMethods @Input populates — after our initial 100ms
  // registerFormNavigation runs. Setter fires the moment the ref binds.
  private _fallbackLink: ElementRef;
  @ViewChild('fallbackLink', { static: false })
  set fallbackLinkRef(el: ElementRef) {
    this._fallbackLink = el;
    if (el && this.isTV && this.steps === 1) {
      setTimeout(() => this.registerFormNavigation(), 0);
    }
  }
  get fallbackLink(): ElementRef { return this._fallbackLink; }

  isTV = false;
  focusedFieldIndex = -1;
  private focusSubscription: Subscription;
  private regionId = 'auth-form-region';
  private otpAbortController: AbortController | null = null;

  constructor(
    private dialog:MatDialog,
    private toastr: ToastrService,
    private authService: AuthenticateserviceService,
    private fb: FormBuilder,
    private categService:CategoryService,
    private toastrService: CustomControlsService,
    private router: Router,
    private tvNav: TVNavigationService,
    private tvKeyboard: TvKeyboardService,
    private deviceService: DeviceService,
    private ngZone: NgZone,
    private cdr: ChangeDetectorRef,
    private guestTokenService: GuestTokenService
    ) {
      const firebaseConfig = {
        apiKey: "AIzaSyA1Xl6t7H0F-niShxXFCBFAAT-8l_v6zq0",
        authDomain: "toqqer-app-dev-e5f3e.firebaseapp.com",
        databaseURL: "https://toqqer-app-dev-e5f3e.firebaseio.com",
        projectId: "toqqer-app-dev-e5f3e",
        storageBucket: "toqqer-app-dev-e5f3e.appspot.com",
        messagingSenderId: "470163066954",
        appId: "1:470163066954:web:5642c6aa16311e47ba56b3",
        measurementId: "G-F1MTN5WSRY"
      };
      if (!firebase.apps.length) {
        firebase.initializeApp(firebaseConfig);
      }
      this.isTV = this.deviceService.isTV();
    }
  
  ngOnInit() {
    this.formGroup = this.fb.group ({
      email: ['', [Validators.required, Validators.email]],
      tcAgree: [false, Validators.requiredTrue],
      optNumber: ['', [Validators.minLength(6),Validators.maxLength(6)]]
    });
  }

  getDialCodeByName(countryName) {
    const country = countryPhoneCodes.find(c => c.name.toLowerCase() === countryName.toLowerCase());
    return country ? country.dial_code : null;
  }
  
  enforceMaxLength(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/\D/g, '').slice(0, 10); // digits only, max 10
    this.formGroup.get('phoneNumber')?.setValue(input.value, { emitEvent: false });
  }  

  getOtpDigits(): string[] {
    return Array.from({ length: 6 }, (_, i) => i.toString());
  }

  get activeMethods(): any[] {
    return this.authMethods || [];
  }

  get backupAuthMethod(): string {
    const methods = this.activeMethods;
    if (methods.length < 2) return '';
    const currentIndex = methods.findIndex(m => m.method === 'EMAIL');
    if (currentIndex === -1) return '';
    const nextIndex = (currentIndex + 1) % methods.length;
    return currentIndex !== nextIndex ? methods[nextIndex].method : '';
  }

  switchAuthMethod(method: string): void {
    this.authTypeChange.emit('PHONE');
  }

  getMethodLabel(method: string): string {
    switch (method) {
      case 'WHATSAPP': return 'WhatsApp';
      case 'EMAIL': return 'Email';
      default: return 'SMS';
    }
  }

  ngAfterViewInit() {
    if (this.isTV) {
      setTimeout(() => {
        this.registerFormNavigation();

        // Subscribe to focus changes
        this.focusSubscription = this.tvNav.focus$.subscribe(focusKey => {
          if (focusKey && focusKey.startsWith(this.regionId + ':')) {
            this.focusedFieldIndex = parseInt(focusKey.split(':')[1], 10);
          } else if (this.focusedFieldIndex !== -1) {
            this.focusedFieldIndex = -1;
          }
        });
      }, 100);

    }
  }

  onOtpChange(otp: string): void {
    this.otpValue = otp;
  }

  toggleOtpVisibility(): void {
    this.showOtp = !this.showOtp;
  
    if (this.otpContainer) {
      const inputs = this.otpContainer.nativeElement.querySelectorAll('input') as NodeListOf<HTMLInputElement>;
      inputs.forEach((input: HTMLInputElement) => {
        if (this.showOtp) {
          input.classList.remove('masked');
        } else {
          input.classList.add('masked');    
        }
      });
    }
  }
  

  onWrongNumberClick(){
    this.steps = 1;
    this.stepChange.emit(this.steps);
    this.isResendDisabled = false;
    this.remainingTime = 60;

    // Re-register form navigation after step change
    if (this.isTV) {
      setTimeout(() => this.registerFormNavigation(), 100);
    }
  }

  get f() {
    return this.formGroup.controls;
  }

  nextStep () {
    const countryCode = this.getDialCodeByName(this.selectedCountry);
    this.loading = true;
    this.authService.toqqerSignInWithEmail(this.formGroup.value.email, this.deviceId).subscribe((result)=>{
      if(result.status === 'SUCCESS'){
        this.loading = false;
        this.steps = 2;
        this.stepChange.emit(this.steps);
        this.verificationId = result.verificationId;
        this.showInfo(result.message);
        this.startTimer();

        if (this.isTV) {
          setTimeout(() => this.registerFormNavigation(), 100);
          // Re-register again once Resend / Wrong number ViewChild refs have
          // had time to populate after the *ngIf="steps === 2" template render
          // completes. Without this catch-up, only [otpContainer, submitBtn]
          // makes it into the focus list, and Resend/Wrong are unreachable.
          setTimeout(() => this.registerFormNavigation(), 600);
        } else {
          this.cdr.detectChanges();
          setTimeout(() => this.initAutoOtp(), 300);
        }
      }else if(result.status === 'FAILED'){
        this.loading = false;
        this.showWarning(result.message);
      }
    },(error)=>{
      this.loading = false;
      this.showError(error?.error?.message || error?.message);
    })
  }

  onResendOtpClick(){
    this.loading = true;
    const countryCode = this.getDialCodeByName(this.selectedCountry);
    this.authService.toqqerSignInWithPhoneNumber(this.formGroup.value.email, countryCode, this.deviceId, 'EMAIL').subscribe((result)=>{
      if(result.status === 'SUCCESS'){
        this.loading = false;
        this.showInfo(result.message);
        this.verificationId = result.verificationId;
        this.startTimer();
      }else if(result.status === 'FAILED' && result.message === 'OTP is expired, User needs new session'){
        this.loading = false
        this.steps = 1;
        this.stepChange.emit(this.steps);
        this.showWarning(result.message);
      }else{
        this.loading = false;
        this.showWarning(result.message)
      }
    },(error)=>{
      this.loading = false;
      this.showError(error?.message);
    })
  }

  startTimer() {
    this.isResendDisabled = true; 
    const interval = setInterval(() => {
      if (this.remainingTime > 0) {
        this.remainingTime--;
      } else {
        clearInterval(interval);
        this.isResendDisabled = false;
        this.remainingTime = 60;
      }
    }, 1000);
  }

  onSubmit() {
    console.log("this.formGroup.value.optNumber:", this.formGroup.value.optNumber);
    if(this.otpValue){
      const deviceId =  localStorage.getItem('deviceId');
      this.loading = true;
      this.authService.toqqerVerifyOtp(this.otpValue,this.verificationId, deviceId).subscribe((otpResult)=>{
        this.loading = false;
        if(otpResult.status === 'SUCCESS'){
          localStorage.setItem('refreshToken',otpResult.response.idToken)
          if(otpResult.response.idToken){
            this.authService.toqqerUserLogin(otpResult.response.idToken).subscribe((userDetails:any)=>{
              this.guestTokenService.clearGuestState();
              localStorage.setItem('token', userDetails.refreshToken);
              this.authService.isAuthenticatedSubject.next(true);
              localStorage.setItem('screenName', userDetails.data.screenName);
              localStorage.setItem('userName', userDetails.data.userName)
              localStorage.setItem('userId', userDetails.data.localUserId);
              localStorage.setItem('profileImage', userDetails.data.profileImage);
              localStorage.setItem('description', userDetails.data.description);
              localStorage.setItem('identifier',userDetails.data.identifier);
              localStorage.setItem('appDarkMode','true');
              const redirectUrl = localStorage.getItem('redirectAfterLogin');
              localStorage.removeItem('redirectAfterLogin');
              if (redirectUrl && !redirectUrl.startsWith('/login')) {
                this.router.navigateByUrl(redirectUrl, { replaceUrl: true });
              } else {
                const wlChannel = localStorage.getItem('wl_channel');
                const defaultRoute = wlChannel ? `/${wlChannel}/v` : '/v';
                this.router.navigate([defaultRoute], { replaceUrl: true });
              }
              this.showSuccess(`Welcome! 🖐️ ${userDetails.data.screenName}`)
            },(error)=>{
              this.steps = 1;
              this.showError(error?.message);
              this.loading = false;
            })
          }else if(otpResult.response.preRegToken!=''){
            console.log("New user logged in");
            localStorage.setItem('preRegToken', otpResult.response.preRegToken);
            localStorage.setItem('new_number', this.formGroup.value.phoneNumber);
            this.router.navigate(['/registration'], { replaceUrl: true });
          }
        }else if(otpResult.status === 'FAILED' && otpResult.message === 'OTP is expired, User needs new session'){
          this.loading = false
          this.steps = 1;
          this.stepChange.emit(this.steps);
          this.showWarning(otpResult.message);
        }else if(otpResult.status === 'FAILED' && otpResult.message === 'OTP is not verified, Crossed maximum attempt of verification, Record is expired, User needs new session'){
          this.loading = false;
          this.steps = 1;
          this.stepChange.emit(this.steps);
          this.showWarning(otpResult.message);
        }else{
          this.loading = false;
          this.showError(otpResult.message);
        }
      },(error)=>{
        this.showError("Something went wrong. Please check your connection...")
        this.loading = false;
      })
    }
  };

  openTermsDialog(url:string){
    const dialogRef = this.dialog.open(TermsAndConditionsComponent,{
      width:'auto',
      data:{url}
    })
    dialogRef.afterClosed().subscribe(result=>{
      console.log("Dialog CLosed")
    })
  }

  private fillOtpInputBoxes(value: string): void {
    if (!this.otpContainer) return;
    const inputs = this.otpContainer.nativeElement.querySelectorAll('input') as NodeListOf<HTMLInputElement>;
    inputs.forEach((input: HTMLInputElement, i: number) => {
      input.value = value[i] || '';
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });
  }

  private initAutoOtp(): void {
    if (this.otpContainer) {
      const inputs = this.otpContainer.nativeElement.querySelectorAll('input') as NodeListOf<HTMLInputElement>;
      inputs.forEach((input: HTMLInputElement) => {
        input.setAttribute('autocomplete', 'one-time-code');
      });
    }

    if (!('OTPCredential' in window)) {
      console.log('[WebOTP] OTPCredential not supported');
      return;
    }

    const ac = new AbortController();
    this.otpAbortController = ac;

    console.log('[WebOTP] listening for OTP...');

    (navigator.credentials as any).get({
      otp: { transport: ['sms'] },
      signal: ac.signal
    }).then((otpCredential: any) => {
      console.log('[WebOTP] credential received:', otpCredential);
      const code: string = otpCredential?.code;
      console.log('[WebOTP] code:', code);
      if (!code) {
        console.log('[WebOTP] code is empty, aborting');
        return;
      }
      this.ngZone.run(() => {
        this.fillOtpCode(code);
      });
    }).catch((err: any) => {
      console.log('[WebOTP] error:', err);
    });
  }

  private fillOtpCode(code: string, attempt: number = 0): void {
    console.log('[WebOTP] fillOtpCode attempt', attempt, 'code:', code);
    this.otpValue = code;

    if (this.ngOtpInput) {
      console.log('[WebOTP] calling ngOtpInput.setValue()');
      this.ngOtpInput.setValue(code);
    } else {
      console.log('[WebOTP] ngOtpInput ref is null');
    }

    const otpInputs = document.querySelectorAll('ng-otp-input input') as NodeListOf<HTMLInputElement>;
    console.log('[WebOTP] found', otpInputs.length, 'OTP input elements via document query');
    if (otpInputs.length > 0) {
      otpInputs.forEach((input: HTMLInputElement, i: number) => {
        const digit = code[i] || '';
        input.value = digit;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    if (!this.ngOtpInput && otpInputs.length === 0 && attempt < 5) {
      console.log('[WebOTP] refs not ready, retrying in 300ms...');
      setTimeout(() => {
        this.cdr.detectChanges();
        this.fillOtpCode(code, attempt + 1);
      }, 300);
      return;
    }

    if (code.length === this.otpConfig.length) {
      const active = document.activeElement as HTMLElement;
      if (active) active.blur();
      setTimeout(() => this.onSubmit(), 500);
    }
  }

  showPassword:boolean;
  togglePassword(){
    this.showPassword = !this.showPassword;
  }

  showInfo(message:any) {
    this.toastrService.showNotification(
      'info',
      '',
      message,
      3000
    );
  }

  showSuccess(message:any) {
    this.toastrService.showNotification(
      'success',
      '',
      message,
      3000
    );
  }

  showError(message:any) {
    this.toastrService.showNotification(
      'error',
      '',
      message,
      3000
    );
  }

  showWarning(message:any) {
    this.toastrService.showNotification(
      'warning',
      '',
      message,
      3000
    );
  }

  /**
   * Register form fields with TV navigation
   * Step 1: email input, checkbox, submit button
   * Step 2: OTP container, submit button, resend, wrong number
   */
  registerFormNavigation(): void {
    if (!this.isTV) return;

    // Unregister any existing region
    this.tvNav.unregisterRegion(this.regionId);

    if (this.steps === 1) {
      // Email input step
      const focusableItems: ElementRef[] = [];

      if (this.emailInput) focusableItems.push(this.emailInput);
      if (this.tcCheckbox) focusableItems.push(this.tcCheckbox);
      if (this.submitBtn) focusableItems.push(this.submitBtn);
      // Always include fallback link so user can switch back to phone-based
      // methods. Without this, picking Email locks the user into Email forever.
      if (this.fallbackLink) focusableItems.push(this.fallbackLink);

      if (focusableItems.length > 0) {
        this.tvNav.registerRegion({
          id: this.regionId,
          type: 'form',
          elementRef: this.emailInput || this.tcCheckbox || this.submitBtn,
          focusableItems
        });
      }
    } else if (this.steps === 2) {
      // OTP verification step
      const focusableItems: ElementRef[] = [];

      // OTP container (focusable to open keyboard)
      if (this.otpContainer) focusableItems.push(this.otpContainer);

      // Submit button
      if (this.submitBtn) focusableItems.push(this.submitBtn);

      // Resend and Wrong Number buttons
      if (this.resendBtn) focusableItems.push(this.resendBtn);
      if (this.wrongNumberBtn) focusableItems.push(this.wrongNumberBtn);

      if (focusableItems.length > 0) {
        const firstElement = focusableItems[0];
        this.tvNav.registerRegion({
          id: this.regionId,
          type: 'form',
          elementRef: firstElement,
          focusableItems
        });
        // Explicitly activate so focus lands on OTP wrapper after step transition
        this.tvNav.activateRegion(this.regionId, 0);
        // Prevent ng-otp-input internal inputs from grabbing focus & arrow keys
        this.disableNativeOtpFocus();
      }
    }
  }

  /**
   * On TV: set tabindex=-1 and readonly on ng-otp-input's internal inputs.
   * Prevents the ng-otp-input library from grabbing native focus + intercepting
   * arrow keys, which would trap D-pad navigation inside the OTP wrapper and
   * make Resend OTP / Wrong number? unreachable.
   */
  private disableNativeOtpFocus(): void {
    if (!this.isTV || !this.otpContainer) return;
    const neutralize = () => {
      const inputs = this.otpContainer.nativeElement.querySelectorAll('input');
      inputs.forEach((input: HTMLInputElement) => {
        input.setAttribute('tabindex', '-1');
        input.setAttribute('readonly', 'readonly');
        input.setAttribute('inputmode', 'none');
        input.style.caretColor = 'transparent';
        input.blur();
      });
    };
    // Run twice — ng-otp-input can render its inputs late
    setTimeout(neutralize, 50);
    setTimeout(neutralize, 300);
  }

  /**
   * Called when user presses Enter on email input field
   * Opens grid keyboard for email entry
   */
  onEmailInputActivate(): void {
    if (!this.isTV) return;

    const currentValue = this.formGroup.get('email')?.value || '';

    this.tvKeyboard.show({
      initialValue: currentValue,
      inputType: 'email',
      maxLength: 100,
      placeholder: 'Enter email address',
      onSubmit: (value: string) => {
        this.formGroup.patchValue({ email: value });
        this.tvKeyboard.restoreFocus();
      },
      onCancel: () => {
        this.tvKeyboard.restoreFocus();
      }
    });
  }

  /**
   * Handle OTP box activation - open keyboard for OTP digit entry
   */
  onOtpBoxActivate(boxIndex: number): void {
    if (!this.isTV) return;

    // Get current OTP value
    const currentOtp = this.otpValue;

    this.tvKeyboard.show({
      initialValue: currentOtp,
      inputType: 'tel',
      maxLength: 6,
      placeholder: 'Enter 6-digit OTP',
      onSubmit: (value: string) => {
        this.otpValue = value;
        this.onOtpChange(value);
        this.tvKeyboard.restoreFocus();
      },
      onCancel: () => {
        this.tvKeyboard.restoreFocus();
      }
    });
  }

  ngOnDestroy(): void {
    if (this.focusSubscription) {
      this.focusSubscription.unsubscribe();
    }
    if (this.isTV) {
      this.tvNav.unregisterRegion(this.regionId);
    }
    if (this.otpAbortController) {
      this.otpAbortController.abort();
    }
  }
}